module.exports = __webpack_public_path__ + "img/my-story-hotel-tejo.f502dd4a.jpg";